"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLogo = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavLogo = require("./NavLogo.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NavLogo = function NavLogo(_ref) {
  var href = _ref.href,
      to = _ref.to,
      children = _ref.children,
      altText = _ref.altText,
      showBackground = _ref.showBackground,
      isColored = _ref.isColored,
      height = _ref.height,
      width = _ref.width;
  var logoLinkProps = {
    showBackground: showBackground,
    href: href,
    to: to,
    alt: altText,
    isColored: isColored,
    height: height,
    width: width
  };
  return to ? _react.default.createElement(_NavLogo.StyledLogoRouterLink, logoLinkProps, children) : _react.default.createElement(_NavLogo.StyledLogoLink, logoLinkProps, children);
};
/**
 * Definition of default values for component props
 */


exports.NavLogo = NavLogo;
NavLogo.defaultProps = {
  href: undefined,
  to: undefined,
  altText: undefined,
  isColored: true,
  height: '30px',
  width: '96px'
};
NavLogo.propTypes = {
  href: _propTypes.default.string,
  to: _propTypes.default.string,
  altText: _propTypes.default.string,
  isColored: _propTypes.default.bool,
  height: _propTypes.default.string,
  width: _propTypes.default.string
};